export default{
        column: [
                {
                  type: 'select',
                  label: '项目名称',
                  dicData: [],
                  cascaderItem: [],
                  span: 6,
                  display: true,
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  prop: 'projectId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择下拉选择器'
                    }
                  ]
                },
                {
                  type: 'select',
                  label: '仓库名称',
                  dicData: [],
                  cascaderItem: [],
                  span: 6,
                  display: true,
                
                  props: {
                    label: 'name',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'warehouseId',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择仓库'
                    }
                  ]
                },
                {
                  label:'出库单号',
                  prop:'outboundNo',
                  span:6,

                },
                {
                  type: 'select',
                  label: '领用科室',
                  dicData: [
                  ],
                  cascaderItem: [],
                  span: 6,
                  dataType:'string',
                  display: true,
                  props: {
                    label: 'title',
                    value: 'id'
                  },
                  formslot:true,
                  prop: 'requisitionDept',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择科室'
                    }
                  ]
                },

               
                {
                  type: 'select',
                  label: '申请人',
                  dicData: [],
                  span: 7,
                  display: true,
                  filterable:true,
                  // formslot:true,
                  dataType:'string',
                  props: {
                    label: 'realNameAndPhone',
                    value: 'id'
                  },
                  prop: 'requisitionUserNamePhone',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请选择申请人'
                    }
                  ]
                },
               
                {
                  type: 'input',
                  label: '领用单号',
                  disabled:true,
                  span:7,
                  prop: 'linkNo',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '单号'
                    }
                  ]
                },
                {
                  type: 'input',
                  label: '出库人员',
                  disabled:true,
                  span:7,
                  prop: 'outboundUserNamePhone',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '单号'
                    }
                  ]
                },
                {
                  type: 'datetime',
                  label: '出库时间',
                  cascaderItem: [],
                  span: 7,
                  disabled:true,
                  display: true,
                  dicOption: 'static',
                  props: {
                    label: 'label',
                    value: 'value'
                  },
                  prop: 'outboundTime',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请出库时间'
                    }
                  ],
                  value:new Date(),
                  format: 'yyyy-MM-dd HH:mm:ss',
                  valueFormat: 'yyyy-MM-dd HH:mm:ss'
                },
                {
                  type: 'textarea',
                  label: '领用备注',
                  span: 24,
                  maxlength: 300,
                  showWordLimit: true,
                  display: true,
                  prop: 'remark'
                },
                {
                  type: 'textarea',
                  label: '',
                  labelWidth:0,
                  span: 24,
                  formslot:true,
                  display: true,
                  prop: 'dataList'
                }
              ],
              labelPosition: 'right',
              labelSuffix: '：',
              labelWidth: 100,
              gutter: 0,
              submitBtn: true,
              submitIcon:'none',
              submitText: '确认领料',
              emptyBtn:false,
              menuBtn: true,
              menuPosition: 'center',
              disabled:true,
              
}
